// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3HK5r","requiredAsterisk":"Info_requiredAsterisk__2ibjM"};